function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import classNames from '../../../_snowpack/pkg/classnames.js';
import { colors } from '../colors.js';
const Outer = styled.span.withConfig({
  displayName: "radio-button__Outer",
  componentId: "sc-1vf8byi-0"
})(["display:inline-flex;position:relative;cursor:pointer;"]);
const Box = styled.span.withConfig({
  displayName: "radio-button__Box",
  componentId: "sc-1vf8byi-1"
})(["--size:18px;display:inline-flex;align-items:center;justify-content:center;position:relative;z-index:1;width:var(--size);height:var(--size);border-radius:50%;border-width:2px;border-style:solid;border-color:hsl(0,0%,87%);&.checked{background-color:hsl(166,100%,96%);border-color:", ";&::after{opacity:1;transform:none;}}&::after{--size:70%;content:'';display:inline-block;background:", ";width:var(--size);height:var(--size);border-radius:50%;transition:transform 100ms,opacity 100ms;transform:scale(0.35);opacity:0;}"], colors.glacier, colors.glacier);
const Input = styled.input.withConfig({
  displayName: "radio-button__Input",
  componentId: "sc-1vf8byi-2"
})(["cursor:pointer;height:100%;left:0;margin:0;opacity:0;position:absolute;top:0;width:100%;&[disabled]{cursor:not-allowed;}"]);
export function RadioButton(props) {
  const {
    checked,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(Outer, {
    className: classNames({
      checked
    })
  }, /*#__PURE__*/React.createElement(Box, {
    className: classNames({
      checked
    }),
    "data-checked": checked
  }), /*#__PURE__*/React.createElement(Input, _extends({
    type: "radio",
    checked: checked,
    "data-checked": checked,
    "aria-checked": checked
  }, rest)));
}